import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"pencil\">\n    <path d=\"m12.12 3.9.822-.81c.393-.399.414-.85.04-1.223l-.77-.857c-.367-.372-.834-.338-1.229.054l-.82.803 1.957 2.034ZM3.4 12.57l7.973-7.939-1.951-2.026-7.98 7.94-.682 1.72c-.1.28.63 1.07.883.977l1.757-.671Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol